'use strict'
const merge = require('webpack-merge')
const prodEnv = require('./prod.env')

module.exports = merge(prodEnv, {
  NODE_ENV: '"development"',
  VUE_APP_BACKEND_URL: '"http://localhost:3005"',
  VUE_APP_GOOGLE_TOKEN: '"500054702866-ml4nivm37g975mj5c4u86olrotuq4p5b.apps.googleusercontent.com"',
  BROWSER_LANGUAGE: null
})



//////////////////
// WEBPACK FOOTER
// ./config/dev.env.js
// module id = dhIU
// module chunks = 4